import { Typography } from '@mui/material';

type Props = {
  error?: string | null;
};

export default function SubmitError({ error }: Props) {
  if (!error) return null;
  return (
    <Typography variant="body2" color="error" sx={{ textAlign: 'center' }}>
      {error}
    </Typography>
  );
}
